import { render, staticRenderFns } from "./changeDetails.vue?vue&type=template&id=55864062&scoped=true"
import script from "./changeDetails.vue?vue&type=script&lang=js"
export * from "./changeDetails.vue?vue&type=script&lang=js"
import style0 from "./changeDetails.vue?vue&type=style&index=0&id=55864062&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55864062",
  null
  
)

export default component.exports